export default {
    state: {
        referenceHouses: [],
        currentReferenceHouseIndex: -1,
        currentProduct: {},
        currentCustomReferenceHouse: {
            standardFloorApartments: [],
            groundFloorApartments: [],
        },
    },

    getters: {
        referenceHouses: state => state.referenceHouses,
        filteredReferenceHouses: state => {
            if (state.currentProduct.id) {
                return state.referenceHouses.filter(item => item.product.id === state.currentProduct.id)
            }
            return state.referenceHouses
        },
        currentReferenceHouseIndex: state => state.currentReferenceHouseIndex,
        currentProductName: state => state.currentProduct.productName || "Alla",
    },

    mutations: {
        setCurrentReferenceHouseIndex(state, payload) {
            state.currentReferenceHouseIndex = payload
        },
        setCurrentProduct(state, payload) {
            state.currentProduct = payload
        },
        setCurrentCustomReferenceHouse(state, payload) {
            state.currentCustomReferenceHouse = payload
        },
        addStandardFloorApartment(state, payload) {
            state.currentCustomReferenceHouse.standardFloorApartments.push(payload)
        },
        addGroundFloorApartment(state, payload) {
            state.currentCustomReferenceHouse.groundFloorApartments.push(payload)
        },
    }
}



// WEBPACK FOOTER //
// ./assets/vue/houseModel/store/refHousesState.js